// 中国网球公开赛顶部菜单

module.exports = {
  sportType: 'tennis',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'tennisScheduleIndex_TENCO',
          act: true,
        },
        {
          name: '淘汰赛',
          key: 'knockoutRounds',
          routeName: 'tennisKnockoutRoundsIndex_TENCO',
          act: false,
        },
        {
          name: '晋级之路',
          key: 'eventsThemeList',
          routeName: 'tennisEventsThemeListIndex_TENCO',
          act: false,
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'tennisProgramListIndex_TENCO',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'tennisBroadcastListIndex_TENCO',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'tennisDataPackagListIndex_TENCO',
          act: false,
          isOpenWeb: true,
        },
      ],
    },
  ],
}
